import { ResolverTag } from '@ps/web-core-enums';
import { CashierPath } from '@ps/web-pam-types';
import { Link, Translation } from '@ps/web-shared-components';
import React from 'react';

import ResolverLink from '@swf/components/ResolverLink/ResolverLink';

import {
  TXTWCL_For_more_help_with_currency_co_ELL,
  TXTWCL_You_can_change_your_preferred__ELL
} from './HelpSectionContent.messages.json';
import { currency } from './HelpSectionContent.scss';

const HelpSectionContent: React.FC = () => (
  <>
    <Translation
      values={{
        a: (msg: React.ReactNode) => (
          <Link
            className={currency}
            href={CashierPath.ManageCurrencies}
            target="_blank"
            rel="noopener noreferrer"
          >
            {msg}
          </Link>
        )
      }}
      {...TXTWCL_You_can_change_your_preferred__ELL}
    />{' '}
    <Translation
      values={{
        a: (msg: React.ReactNode) => (
          <ResolverLink resolverTag={ResolverTag.HcCurrencyMgt}>{msg}</ResolverLink>
        )
      }}
      {...TXTWCL_For_more_help_with_currency_co_ELL}
    />
  </>
);

export default HelpSectionContent;
